import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Loader2, PackageOpen } from "lucide-react";

const CHAMPS = [["debut", "Stock 01/01"], ["achats", "Achats"], ["comptage", "Comptage 31/12"]];
const val = (v) => (v === null || v === undefined ? "" : String(v));

export const StocksAnnexesDialog = ({ sid, annee, rows, onSaved }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  const ouvrir = () => {
    setForm(Object.fromEntries(rows.map((r) => [r.mp, { debut: r.debut_saisi ? val(r.debut) : "", achats: r.achats_saisi ? val(r.achats) : "", comptage: r.base === "Comptage" ? val(r.stock_fin) : "" }])));
    setOpen(true);
  };

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/etat-stock/stocks-annexes", { societe_id: sid, annee, lignes: form });
      toast.success("Stocks enregistrés");
      setOpen(false);
      onSaved();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Button variant="outline" size="sm" className="gap-2" onClick={ouvrir} data-testid="stocks-annexes-open-btn"><PackageOpen className="h-4 w-4" /> Saisir stocks et achats</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-4xl max-h-[85vh] overflow-y-auto" data-testid="stocks-annexes-dialog">
          <DialogHeader>
            <DialogTitle>Emballages et autres matières — {annee}</DialogTitle>
            <DialogDescription>Stock au 01/01 (vide = stock fin de l'année précédente), achats de l'année et comptage réel au 31/12. Sans comptage, le stock fin = stock début + achats − consommation.</DialogDescription>
          </DialogHeader>
          <table className="w-full text-sm">
            <thead><tr className="text-left text-muted-foreground border-b"><th className="py-2">Article</th><th>Unité</th>{CHAMPS.map(([k, l]) => <th key={k} className="w-32 text-right">{l}</th>)}</tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.mp} className="border-b last:border-0" data-testid={`stocks-annexes-row-${r.mp}`}>
                  <td className="py-1.5 font-medium">{r.mp}<span className="block text-xs text-muted-foreground">Conso. {r.consommation}</span></td>
                  <td>{r.unite}</td>
                  {CHAMPS.map(([k]) => (
                    <td key={k} className="pl-2"><Input className="h-8 text-right" inputMode="decimal" value={form[r.mp]?.[k] ?? ""} placeholder={k === "debut" ? String(r.debut) : k === "achats" ? String(r.achats) : ""}
                      onChange={(ev) => setForm((f) => ({ ...f, [r.mp]: { ...f[r.mp], [k]: ev.target.value } }))} data-testid={`stocks-annexes-${k}-${r.mp}`} /></td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setOpen(false)} data-testid="stocks-annexes-cancel-btn">Annuler</Button>
            <Button onClick={save} disabled={saving} data-testid="stocks-annexes-save-btn">{saving && <Loader2 className="h-4 w-4 animate-spin mr-2" />}Enregistrer</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
